import * as tslib_1 from "tslib";
import { ApiTypes } from '../../types';
import { MediaApi } from '../../services';
import { toSnakeCase } from '../../utils/stringUtils';
var _a = ApiTypes.v1.RelationshipWithGroup, JOINED = _a.JOINED, NONE = _a.NONE, REJECTED_MEMBERSHIP = _a.REJECTED_MEMBERSHIP, PENDING_APPROVAL = _a.PENDING_APPROVAL;
var _b = ApiTypes.v1.GroupPrivacyLevel, SECRET = _b.SECRET, PUBLIC = _b.PUBLIC, PRIVATE = _b.PRIVATE;
/**
 * Model class for wix social groups api
 */
var Group = /** @class */ (function () {
    /**
     * @param {string} id
     * @param {Api} api
     */
    function Group(id, api) {
        var _this = this;
        this.id = id;
        this.api = api;
        this.changeMembership = function (group) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var relationship, actions;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        relationship = group.relationship;
                        actions = (_a = {},
                            _a[PENDING_APPROVAL] = this.withdrawJoinRequest,
                            _a[JOINED] = this.leaveGroup,
                            _a[NONE] = this.joinGroup,
                            _a[REJECTED_MEMBERSHIP] = this.joinGroup,
                            _a);
                        return [4 /*yield*/, actions[relationship](group)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.joinGroup = function (_a) {
            var groupId = _a.groupId, privacyLevel = _a.settings.privacyLevel;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    switch (privacyLevel) {
                        case PUBLIC:
                        case SECRET:
                            return [2 /*return*/, this.api.joinPublicAndSecretGroup(groupId)];
                        case PRIVATE:
                            return [2 /*return*/, this.api.requestToJoinPrivateGroup(groupId)];
                        default:
                            return [2 /*return*/];
                    }
                    return [2 /*return*/];
                });
            });
        };
        this.leaveGroup = function (group) {
            return _this.api.leaveGroup(group.groupId);
        };
        this.withdrawJoinRequest = function (group) {
            return _this.api.withdrawRequestToJoinPrivateGroup(group.groupId);
        };
        var group = Group.createEmpty();
        group.groupId = id;
        this.group = group;
        this.mediaApi = new MediaApi(api);
    }
    Group.createEmpty = function () {
        return {
            groupId: '',
            relationship: ApiTypes.v1.RelationshipWithGroup.NONE,
            roles: [],
            details: {},
            settings: {
                privacyLevel: ApiTypes.v1.GroupPrivacyLevel.PUBLIC,
            },
            memberCount: 0,
        };
    };
    Group.prototype.getGroup = function () {
        return this.group;
    };
    Group.prototype.addUpdatePaths = function (paths) {
        var _this = this;
        if (!this.updatePaths) {
            this.updatePaths = new Set();
        }
        paths.forEach(function (path) { return _this.updatePaths.add(path); });
    };
    Group.prototype.getUpdatePaths = function () {
        return tslib_1.__spread(this.updatePaths).map(toSnakeCase);
    };
    Group.prototype.fetch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getGroup(this.id)];
                    case 1:
                        data = (_a.sent()).data;
                        this.group = data.group;
                        return [2 /*return*/, this.group];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, Group.createEmpty()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.normalizeJSON = function (object) {
        var e_2, _a;
        var normalized = {};
        try {
            for (var _b = tslib_1.__values(Object.entries(object)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), key = _d[0], value = _d[1];
                if (value !== '') {
                    normalized[key] = value;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return normalized;
    };
    /**
     * Creates a group ([Create Group](https://bo.wix.com/wix-docs/rest/business-apis#social-groups.social-groups.create-group))
     * @param {wrapper.wix.social.groups.api.v1.GroupDetails} details
     * @param {wrapper.wix.social.groups.api.v1.GroupSettings} settings
     * @param {File} image
     * @return {Promise<wrapper.wix.social.groups.api.v1.GroupResponse>}
     */
    Group.prototype.create = function (details, settings, image) {
        if (settings === void 0) { settings = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _details, _a, data, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        _details = this.normalizeJSON(details);
                        if (!image) return [3 /*break*/, 2];
                        _a = _details;
                        return [4 /*yield*/, this.uploadImage(image)];
                    case 1:
                        _a.logoUrl = _b.sent();
                        _b.label = 2;
                    case 2:
                        // By default ONE APP set permittedToInviteMembers as GROUP_ADMIN
                        settings.permittedToInviteMembers = ApiTypes.v1.RoleInGroup.GROUP_ADMIN;
                        return [4 /*yield*/, this.api.createGroup(_details, this.normalizeJSON(settings))];
                    case 3:
                        data = (_b.sent()).data;
                        return [2 /*return*/, data];
                    case 4:
                        e_3 = _b.sent();
                        return [2 /*return*/, Group.createEmpty()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.setDetails = function (details) {
        var paths = Object.keys(details).map(function (key) { return "details." + key; });
        this.addUpdatePaths(paths);
        var group = tslib_1.__assign({}, this.group, { details: tslib_1.__assign({}, this.group.details, details) });
        this.group = group;
        return group;
    };
    Group.prototype.setSettings = function (settings) {
        var paths = Object.keys(settings).map(function (key) { return "settings." + key; });
        this.addUpdatePaths(paths);
        var group = tslib_1.__assign({}, this.group, { settings: tslib_1.__assign({}, this.group.settings, settings) });
        this.group = group;
        return group;
    };
    /**
     * Sets a group title, returns new type `ApiTypes.v1.GroupResponse` object
     */
    Group.prototype.setTitle = function (title) {
        this.group = this.setDetails({ title: title });
        return this.group;
    };
    /**
     * Sets a group privacyLevel, returns new type `ApiTypes.v1.GroupResponse` object
     */
    Group.prototype.setPrivacy = function (privacyLevel) {
        this.group = this.setSettings({ privacyLevel: privacyLevel });
        return this.group;
    };
    Group.prototype.setLogoUrl = function (imageResponse) {
        var logoUrl = imageResponse && this.mediaApi.wixStaticImageUrl(imageResponse.file_url);
        this.setDetails({
            logoUrl: logoUrl,
        });
        return this.group;
    };
    Group.prototype.getTitle = function () {
        try {
            return this.group.details.title;
        }
        catch (e) {
            return;
        }
    };
    Group.prototype.getPrivacy = function () {
        try {
            return this.group.settings.privacyLevel;
        }
        catch (e) {
            return;
        }
    };
    Group.prototype.getLogoUrl = function () {
        try {
            return this.group.details.logoUrl;
        }
        catch (e) {
            return;
        }
    };
    Group.prototype.uploadImage = function (file) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, _a, image;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.mediaApi.uploadImage(file)];
                    case 1:
                        res = _b.sent();
                        _a = tslib_1.__read(res.data, 1), image = _a[0];
                        return [2 /*return*/, this.getLogoUrlFromImageResponse(image)];
                }
            });
        });
    };
    Group.prototype.getLogoUrlFromImageResponse = function (image) {
        if (!image) {
            return null;
        }
        //TODO: logo url has max defined target width/height?
        return this.mediaApi.getImageUrl(image);
    };
    Group.prototype.update = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, details, settings, request, data, e_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.group, details = _a.details, settings = _a.settings;
                        request = {
                            fieldMask: {
                                paths: this.getUpdatePaths(),
                            },
                            details: details,
                            settings: settings,
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.patchGroup(this.group.groupId, request)];
                    case 2:
                        data = (_b.sent()).data;
                        this.group = data;
                        return [2 /*return*/, this.group];
                    case 3:
                        e_4 = _b.sent();
                        return [2 /*return*/, this.fetch()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Group.prototype.getMembers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var members, e_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.members.listGroupMembers(this.id)];
                    case 1:
                        members = (_a.sent()).data.members;
                        return [2 /*return*/, members];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Group;
}());
export { Group };
//# sourceMappingURL=Group.js.map